import i18n from '@/language/i18n';
import fileDownload from 'js-file-download';

const MIME_TYPE_PDF = 'application/pdf';
const MIME_TYPES_IMAGE = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
const MIME_TYPES_WORD = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
const MIME_TYPES_EXCEL = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
];
const MAX_FILE_SIZE = 2048;

export default {
  downloadFile(file, fileName) {
    fileDownload(file, fileName);
  },
  previewPdf(file, fileName, mimeType) {
    if (mimeType === MIME_TYPE_PDF) {
      const blob = new Blob([file], { type: MIME_TYPE_PDF });
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
    }
  },
  formatFilename(data) {
    let size =
      data.size / 1000 >= 1000
        ? Math.round((data.size / 1000000 + Number.EPSILON) * 100) / 100 +
        ' MB'
        : Math.round((data.size / 1000 + Number.EPSILON) * 100) / 100 + ' KB';
    size = size.replace('.', ',');

    return data.originalName + ' (' + size + ')';
  },
  formatFileSize(sizeInBytes) {
    let formattedSize =
      sizeInBytes / 1000 >= 1000
        ? Math.round((sizeInBytes / 1000000 + Number.EPSILON) * 100) / 100 +
        ' MB'
        : Math.round((sizeInBytes / 1000 + Number.EPSILON) * 100) / 100 + ' KB';
    formattedSize = formattedSize.replace('.', ',');

    return formattedSize;
  },
  fileSizeCheck(files) {
    if (files.length > 0) {
      for (let i = 0; i <= files.length - 1; i++) {
        let fileSize = files[i]?.data?.size ?? Math.round((files.item(i).size / 1024));
        if (fileSize >= MAX_FILE_SIZE) {
          alert(i18n.t('Validations.fileTooBig'));
          return false;
        }
      }
      return true;
    }
  },
  previewImage(file, fileName, mimeType) {
    if (MIME_TYPES_IMAGE.includes( mimeType )) {
      const blob = new Blob([file], { type: mimeType });
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
    }
  },
  isWordType(mimeType) {
    return MIME_TYPES_WORD.includes(mimeType);
  },
  isExcelType(mimeType) {
    return MIME_TYPES_EXCEL.includes(mimeType);
  },
  isImageType(mimeType) {
    return MIME_TYPES_IMAGE.includes(mimeType);
  },
  isPdfType(mimeType) {
    return MIME_TYPE_PDF == mimeType;
  },
}
